import { Component, Vue, Model } from "vue-property-decorator";
import { Interfaces, Models, odata, apiService } from '@/core/Export';
import store from "@/store";

export module forms {

    // export class onPropertyChangeOptions {
    //     entityName: string = "";
    //     layoutCode: string = "";
    //     id: number = 0;
    //     fieldName: string = "";
    //     newValue: any;
    //     formData: any;
    // }

    export class hlHeader {
        public appEnv = store.state.appEnv;
        private _id: number = -1;

        model = {}
        lines = new Array<hlLine>();
        errors = []

        self;

        constructor(private v: Vue) {
            this.self = this;
        }

        public addLine() {
            let line = new forms.hlLine(this.v);
            line.model = this.onGetNewLine();
            line.model.Id = this.lines.length + 1;
            this.lines.push(line);
            return line;
        }
        public addLineFromModel(model: any) {
            let line = new forms.hlLine(this.v);
            line.model = model;
            line.model.Id = this.lines.length + 1;
            this.lines.push(line);
            return line;
        }

        onGetNewLine() {
        }

        clear() {
            this.lines = new Array<hlLine>();
        }

        removeLine(e) {
            if (this.lines.length === 1) return;
            let id = e.Id;
            var row = this.lines.findIndex(s => s.model.Id == id);
            this.lines.splice(row, 1);
        }

        checkSaveRules(errors) {
            this.onCheckHeaderSaveRules(errors);

            this.lines.forEach(element => {
                var line: hlLine = element as hlLine;
                line.checkSaveRules(errors);
            });
        }

        onCheckHeaderSaveRules(errors) {
        }

        saveAll() {
            this.appEnv.isBusy = true;
            this.errors = [];
            this.checkSaveRules(this.errors);

            if (this.errors.length > 0) {
                return;
            }
            this.onSaveAll();
        }

        onSaveAll() {
        }
    }

    export class hlLine {
        model: any;
        constructor(private v: Vue) {

        }
        removeLine(id) {
            this.v.$emit("deleteLine", this.model)
        }

        checkSaveRules(errors) {
            let res = this.onCheckLineSaveRules(errors);

        }

        onCheckLineSaveRules(errors) {
            return true;
        }
    }

    export class dynamicForm {
        private appEnv = store.getters.appEnv;
        private _id: string = null;
        private _enabled = true;
        public isBusy: boolean;
        private _inEdit: boolean = false;
        private _hasErrors: boolean = false;
        private _header: Models.uiHeader;
        private _Msgs: Interfaces.IMsgs;
        formData: any;
        formOriginalData: any;
        formLayout: Interfaces.IFormLayout;
        colCount = 0;
        labelLocation = "top";
        serverPropChangeList: Array<string>;

        constructor(
            private entityName: string,
            private layoutCode: string,
            public useManualSave = false) {
            this._header = new Models.uiHeader();
            this.serverPropChangeList = new Array<string>();
            this._Msgs = { msgs: [], errors: [], hasErrors: false }
            this.formLayout = { title: "", colCount: 0, items: new Array<any>(), labelLocation: "top", disabled: false, Id: -1, Code: "", typeName: "" };
        }

        edit() {
            this._inEdit = true;
            this.setOption("readOnly", false);
            this.onAfterEdit();
        }

        onAfterEdit() {
        }

        preventEdit() {
            this._inEdit = false;
            this.setOption("readOnly", true);
        }

        cancel() {
            this.updateData(this.formOriginalData);
            this._hasErrors = false;
            this._Msgs = { msgs: [], errors: [], hasErrors: false }
            this._inEdit = false;
            this.setOption("readOnly", true);
        }

        save(): Promise<any> {
            this.setBusy(true);
            var ok = this.validate();
            if (!ok) {
                this.setBusy(false);
                return new Promise((resolve, reject) => {
                    reject({ isSuccess: false } as Interfaces.ICallResult);
                });
            }

            if (!this.changes || this.changes.length === 0) {
                this.cancel();
                this.setBusy(false);
                return new Promise((resolve, reject) => {
                    resolve(
                        { isSuccess: true } as Interfaces.ICallResult
                    );
                });
            };

            this._hasErrors = false;

            return new Promise((resolve, reject) => {
                apiService.saveForm(this.entityName, this._id, this.formData)
                    .then(res => {
                        let response = res as Interfaces.ICallResult;
                        if (response && response.isSuccess) {
                            this.formOriginalData = response.result["formData"];
                            this._id = response.result["entityId"];
                            this.cancel();
                            this.onSaveSuccess(this._id, response);
                            resolve(response);
                        } else {
                            this._Msgs = response.msgs as Interfaces.IMsgs;
                            this._hasErrors = true;
                            reject();
                        }
                        this.setBusy(false);
                    })
                    .catch(err => {
                        this._hasErrors = true;
                        this.setBusy(false);
                        reject(err);
                    })
            })
        }

        customizeItem(item) {
        }

        onSaveSuccess(entityId, call?) {
        }

        private setBusy(value: boolean) {
            this.isBusy = value;
            this.appEnv.isBusy = value;
        }

        private validate(): boolean {
            return true;
            let result = this.validateForm();
            if (result && result.isValid) return true;
            return false;
        }

        load(params?): Promise<any> {
            this.isBusy = true;
            return new Promise((resolve, reject) => {
                apiService.getForm_Post(this.entityName, this._id, params)
                    .then(res => {
                        let response = res as Interfaces.ICallResult;
                        if (response && response.isSuccess) {
                            let result = response.result;
                            this.formOriginalData = {};
                            Object.assign(this.formOriginalData, result["formData"]);
                            let layout = result["formLayout"];
                            this.formLayout = layout;
                            this.prepareItems(this.formLayout.items);
                            this.colCount = layout.colCount;
                            this.labelLocation = layout.labelLocation;
                            resolve(this.formData = result["formData"]);
                        } else {
                            this.appEnv.showErrorDialog(response.msgs.errors);
                            this.isBusy = false;
                            reject("");
                        }
                    })
                    .catch(err => {
                        this.appEnv.showErrorDialog([{ msg: this.appEnv.translate("msgs.generalError") }]);
                        this.isBusy = false;
                        reject("");
                    })
            })
        }

        inServerProcess = false; changes = [];
        onChanged(e) {
            if (this.inServerProcess) return;
            let serverEvent = this.serverPropChangeList.find(s => s === e.dataField)
            if (serverEvent) this.serverOnPropertyChange(e.dataField, e.value);
            let change = {};
            change[e.dataField] = e.value;
            this.changes.push(change);
            if (!serverEvent) this.onFieldDataChange(e);
        }

        onFieldDataChange(e) {
        }

        serverOnPropertyChange(fieldName: string, newValue: any) {
            let params = new Models.onPropertyChangeOptions();
            params.entityName = this.entityName;
            params.id = this.id;
            params.fieldName = fieldName;
            params.newValue = newValue;
            params.formData = this.formData;
            this.inServerProcess = true;

            return new Promise((resolve, reject) => {
                apiService.sendOnPropertyChanged(params)
                    .then(res => {
                        let response = res as Interfaces.ICallResult;
                        if (response && response.isSuccess) {
                            let result = response.result;
                            let data = result["formData"];
                            this.updateData(data);
                            resolve();
                        } else {
                            this.isBusy = false;
                            reject("");
                        }
                        this.inServerProcess = false;
                    })
                    .catch(err => {
                        this.isBusy = false;
                        this.inServerProcess = false;
                        reject("");
                    })
            })
        }

        private setRequiredMsg(caption: string) {
            return caption;
        }

        private prepareItems(items: Array<Interfaces.IFormItem>) {
            items.forEach(element => {
                let dataField = element.dataField;
                let caption = element["caption"];
                if (caption) {
                    let newCaption = this.appEnv.translate("fields." + caption);
                    element["caption"] = newCaption;
                    caption = newCaption;
                }
                let label = element["label"];
                if (label) {
                    let trnsStr = "";
                    if (dataField && label.text == null) {
                        trnsStr = "fields." + dataField;
                    } else {
                        trnsStr = label.text;
                    }
                    let newCaption = this.appEnv.translate(trnsStr);
                    label["text"] = newCaption;
                    caption = newCaption;
                }

                if (element.items && element.items.length > 0) {
                    this.prepareItems(element.items);
                }

                let useServerOnChange = element["useServerOnChange"];
                if (useServerOnChange) {
                    this.serverPropChangeList.push(element.dataField);
                }

                let editorType = element["editorType"];
                if (editorType && editorType === "dxDateBox") {
                    let editorOptions = element["editorOptions"];
                    editorOptions["displayFormat"] = this.appEnv.translate("formats.date");
                }

                let eo = element["editorOptions"];
                if (eo) {
                    let dataSourceName = eo["dataSourceName"];
                    if (dataSourceName) {
                        let ds = odata.getDSByName(dataSourceName);
                        if (ds) eo["dataSource"] = ds;
                    }
                }
            });
        }

        private validateField(dataField, e) {
            if (this.inServerProcess) return;
            let params = new Models.onPropertyChangeOptions();
            params.entityName = this.entityName;
            params.id = this.id;
            params.fieldName = dataField;
            params.newValue = e.value;
            params.formData = this.formData;
            this.inServerProcess = true;

            // return apiService.sendValidateField(params)
            //     .then(call => {
            //         if (call.isSuccess) {
            //             let isValid = call.callResult["isValid"];
            //             if (!isValid) isValid = false;
            //             e.rule.isValid = isValid;

            //             let msg = call.callResult["message"];
            //             e.rule.message = msg;

            //             e.validator.validate();
            //             this.inServerProcess = false;
            //         }
            //     })
            //     .catch(e => {
            //         this.inServerProcess = false;
            //     });
        }

        startUpdate() { }
        endUpdate() { }
        setOption(key, value) { }
        getOption(key) { }
        updateField(dataField, value) { }
        updateData(value) { }
        validateForm(): any { }
        itemOption(field, option, value) { }

        public get msgs() {
            if (this._Msgs) {
                return this._Msgs;
            }
        }

        public get hasErrors() {
            return this._hasErrors;
        }

        public set id(id: string) {
            this._id = id;
        }

        public get id() {
            return this._id;
        }

        public set enabled(value) {
            this._enabled = value;
        }

        public get enabled() {
            return this._enabled;
        }

        public get inEdit() {
            return this._inEdit;
        }

        public get header() {
            return this._header;
        }
    }
}